import { render } from "./DashboardArrivals.vue?vue&type=template&id=0d418220&ts=true"
import script from "./DashboardArrivals.vue?vue&type=script&lang=ts"
export * from "./DashboardArrivals.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__